import { createSlice } from "@reduxjs/toolkit";

const bankSliceInd = createSlice({
  name: "bankInd",
  initialState: {
    bankName: null,
    accountNumber: null,
    accountType: null,
    swiftCode: null,
    accountHolderName: null,
  },
  reducers: {
    setBankNameRedux: (state, { payload: { bankName } }) => {
      state.bankName = bankName;
    },
    setAccountNoRedux: (state, { payload: { accountNumber } }) => {
      state.accountNumber = accountNumber;
    },
    setAccountTypeRedux: (state, { payload: { accountType } }) => {
      state.accountType = accountType;
    },

    setSwiftCodeReduct: (state, { payload: { swiftCode } }) => {
      state.swiftCode = swiftCode;
    },
    setAccountHolderNameRedux: (state, { payload: { accountHolderName } }) => {
      state.accountHolderName = accountHolderName;
    },
  },
});

export const {
  setBankNameRedux,
  setAccountNoRedux,
  setAccountTypeRedux,
  setSwiftCodeReduct,
  setAccountHolderNameRedux,
} = bankSliceInd.actions;

export default bankSliceInd.reducer;
